import { Alert } from "@mui/material"

export function TaskReadOnlyWarning({ item }) {
    return (
        <Alert severity="warning" sx={{ py: 0.5 }}>
            {item}
        </Alert>
    )
}
